export default {
  name: 'App',
  created() {
    localStorage.clear();
  },
  mounted() {}
};